import React from 'react';
import { Box } from '@mui/material';
import FindSupplier from './FindSupplier';
//import SearchSuppliers from './SearchSupplier';
// import NewOffers from './NewOffers';
// import InviteSupplier from './InviteSupplier';

function Supplier() {

    return (
        <Box
        sx={{
            marginTop: {
                xs: "68px",
                md: "0px",
              },
        }}
        >

            
            {/* <NewOffers />
            <InviteSupplier /> 
            <SearchSuppliers  />*/}
            <FindSupplier/>
        </Box>
    );
}

export default Supplier;
